var map = {
	"./en/account.json": 41036,
	"./en/actions.json": 40204,
	"./en/auth.json": 86839,
	"./en/entities.json": 75942,
	"./en/footer.json": 80830,
	"./en/incidents.json": 73460,
	"./en/landing.json": 53588,
	"./en/leaderboard.json": 78252,
	"./en/login.json": 59854,
	"./en/popovers.json": 99691,
	"./en/reports.json": 40504,
	"./en/sponsors.json": 55426,
	"./en/submit.json": 89113,
	"./en/submitted.json": 31182,
	"./en/translation.json": 75372,
	"./en/validation.json": 95118,
	"./en/variants.json": 89887,
	"./en/wordcount.json": 31780,
	"./es/account.json": 29671,
	"./es/actions.json": 30803,
	"./es/auth.json": 1730,
	"./es/entities.json": 62299,
	"./es/footer.json": 8579,
	"./es/incidents.json": 32375,
	"./es/landing.json": 92307,
	"./es/leaderboard.json": 10615,
	"./es/login.json": 17129,
	"./es/popovers.json": 55926,
	"./es/reports.json": 72883,
	"./es/sponsors.json": 69735,
	"./es/submit.json": 67080,
	"./es/submitted.json": 69009,
	"./es/translation.json": 99699,
	"./es/validation.json": 90091,
	"./es/variants.json": 68594,
	"./es/wordcount.json": 12719,
	"./fr/account.json": 49355,
	"./fr/actions.json": 33855,
	"./fr/auth.json": 33982,
	"./fr/entities.json": 55167,
	"./fr/footer.json": 30503,
	"./fr/incidents.json": 24563,
	"./fr/landing.json": 31391,
	"./fr/leaderboard.json": 63003,
	"./fr/login.json": 68941,
	"./fr/popovers.json": 96770,
	"./fr/reports.json": 16895,
	"./fr/sponsors.json": 90555,
	"./fr/submit.json": 51020,
	"./fr/submitted.json": 87029,
	"./fr/translation.json": 31047,
	"./fr/validation.json": 61303,
	"./fr/variants.json": 39974,
	"./fr/wordcount.json": 92155,
	"./ja/account.json": 83358,
	"./ja/actions.json": 92222,
	"./ja/auth.json": 89477,
	"./ja/entities.json": 3796,
	"./ja/footer.json": 44228,
	"./ja/incidents.json": 4798,
	"./ja/landing.json": 88962,
	"./ja/leaderboard.json": 98654,
	"./ja/login.json": 24252,
	"./ja/popovers.json": 52581,
	"./ja/reports.json": 58490,
	"./ja/sponsors.json": 13100,
	"./ja/submit.json": 94655,
	"./ja/submitted.json": 61200,
	"./ja/translation.json": 77938,
	"./ja/validation.json": 46024,
	"./ja/variants.json": 8333,
	"./ja/wordcount.json": 82814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31991;